import React, {useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import {v4 as uuid} from 'uuid';

// core components
import IndexNavbar from "components/Navbars/IndexNavbar";
import {useIsBusy} from "hooks/useBusy";
import {APIRequest} from "utils/ApiRequest";
import {toast} from 'react-toastify';

function LoginPage() {
  const history = useNavigate()
  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const busy = useIsBusy();

  React.useEffect(() => {
    document.body.classList.add("login-page");
    document.body.classList.add("sidebar-collapse");
    document.documentElement.classList.remove("nav-open");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;

    let userInfo = localStorage.getItem('user-info');
    if (userInfo != null) {
      userInfo = JSON.parse(userInfo);
      if (userInfo.session != null) {
        history("/index");
      }
    }

    return function cleanup() {
      document.body.classList.remove("login-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value.trim());
  };

  function handleLoginSubmit() {
    if (busy) {
      return;
    }
    if ((email === null || email === "") || (password === null || password === "")) {
      toast('Email & Password, both are Mandatory!', {type : "error"});
    }
    else if (!isValidEmail(email)) {
      toast.error('Email is invalid!');
    } else {
      let iid = uuid();
      APIRequest(
        null,
        "/login",
        {
          email, password, iid
        },
        (res) => {
          localStorage.setItem('user-info', JSON.stringify(res.data));
          localStorage.setItem('user-iid', iid);
          history("/dmPass");
        },
        null,
        { busy: "Signing you in…" }
      );
    }
  }

  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleLoginSubmit();
    }
  };

  return (
    <>
      <IndexNavbar />
      <div className="hm-auth">
        <div className="hm-auth-card">
          <img
            className="hm-auth-logo"
            src={require("assets/img/now-logo.png")}
            alt="SORRBA"
          />
          <h1 className="hm-auth-title">Welcome back</h1>
          <p className="hm-auth-sub">Sign in to your SORRBA account</p>

          <label className="hm-auth-label" htmlFor="hm-email">
            Email
          </label>
          <input
            id="hm-email"
            className="hm-auth-input"
            type="email"
            placeholder="you@example.com"
            onChange={handleEmailChange}
            onKeyDown={handleKeyDown}
          />

          <label className="hm-auth-label" htmlFor="hm-password">
            Password
          </label>
          <input
            id="hm-password"
            className="hm-auth-input"
            type="password"
            placeholder="Enter your password"
            onChange={handlePasswordChange}
            onKeyDown={handleKeyDown}
          />

          <button className="hm-auth-btn" onClick={handleLoginSubmit} disabled={busy}>
            {busy ? "Signing in…" : "Login"}
          </button>

          <div className="hm-auth-links">
            <Link to="/forgotPasswd">Reset password</Link>
            <Link to="/signup">Create account</Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default LoginPage;
